'use client'
// 各ページでのエラーをキャッチ

import ErrorLayout from '@/components/Layouts/ErrorLayout'
import getStatusCode from '@/utility/errorUtils'
import { useEffect } from 'react'

interface ErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') console.error('Page Error:', error)
  }, [error])

  const statusCode = getStatusCode(error)

  return <ErrorLayout statusCode={statusCode} message={error.message} standalone={true} />
}
